"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { useI18n } from "@/lib/i18n";

export default function RootRedirect() {
  const router = useRouter();
  const { status } = useSession();
  const { t } = useI18n();

  useEffect(() => {
    if (status === "authenticated") {
      router.replace("/home");
    } else if (status === "unauthenticated") {
      router.replace("/login");
    }
  }, [router, status]);

  return (
    <div style={{ padding: 24 }}>
      <p>{t("common.loading", "Loading…")}</p>
    </div>
  );
}
